export enum ReviewData {
  RATING = 'rating',
  TITLE = 'title',
  DATE_AUTHOR = 'dateAuthor',
  TEXT = 'text',
  RESPONSE = 'response',
  VOTE = 'vote',
}
export type IReviewLayout = Array<ReviewData> | Array<IReviewLayout>
